let dealData = [
    {
        id: 1,
        img: "assets/images/dealimg1.png",
        subheading: "FLASH DEAL",
        heading: " Sale Upto 30% Off Clothes",
        button: "Go to Shop"

    },
    {
        id: 2,
        img: "assets/images/dealimg2.png",
        subheading: "BIG DEAL",
        heading: "Accessories Sale 20%",
        button: "Go to Shop"

    },
]
module.exports = dealData;